module.exports = __webpack_public_path__ + "img/About Us-Strategic Approach.507cf417.jpg";